
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from '../api.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-cfg-gst-ledgers',
  templateUrl: './cfg-gst-ledgers.component.html',
  styleUrls: ['./cfg-gst-ledgers.component.scss']
})
export class CfgGstLedgersComponent implements OnInit {
  ledgers: any = [];
  
  gstINLocation: string = "";
  disAllowGSTLedger: boolean = false;
  gstLedgerList: any = [];
  defaultLedgers = {
    cgstOut: '',
    sgstOut: '',
    igstOut: '',
    csgtIn: '',
    sgstIn: '',
    igstIn: '',
    cgstRevOut: '',
    sgstRevOut: '',
    igstRevOut: '',
  };
  gstLedger = this.defaultLedgers;
  isAdminUser: boolean = false;
  agencyData: any;
  jarvisData: any = [];
  gstLocation: Array<any> = [];
  eGST: boolean = false;
  acctDocLinked: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: APIService,
    private appService: DataService
  ) { }

  ngOnInit(): void {
    this.initializeData();
    this.getGSTLedgers();
  }

  // initializeData() - Initialize component data
  initializeData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.eGST = this.agencyData[0].EGST;

      if (this.agencyData[0].Locations) {
        const locations = JSON.parse(this.agencyData[0].Locations);
        this.gstLocation = [...new Map(locations.filter((o: any) => !o.IsD).map((item: any) => [item.GST, item])).values()];
        this.gstINLocation = this.gstLocation[0]?.GST;
      }
      this.acctDocLinked = this.agencyData[0]?.AcctDocLinked == false ? false : true; 
    }

    if (this.agencyData[0].AdminUserID == this.jarvisData[0].UserID) {
      this.isAdminUser = true;
    }

    let ledgersJSON = this.apiService.getCookie("Ledger");
    if (ledgersJSON) {
      this.ledgers = JSON.parse(ledgersJSON);
    }
  }

  // closeModal() - Close modal
  closeModal() {
    this.activeModal.dismiss();
  }

  // getGSTLedgers() - GST Ledgers Get
  getGSTLedgers() {
    let tmpERP_cfg = this.apiService.getCookie('ERP_Cfg');
    var cfg_AgnCfg = [];
    if (tmpERP_cfg) {
      cfg_AgnCfg = JSON.parse(tmpERP_cfg);
      if (cfg_AgnCfg[0].GSTLedgers) {
        this.gstLedgerList = JSON.parse(cfg_AgnCfg[0].GSTLedgers);
      }
    }

    // This section for multi GST
    if (this.gstLedgerList.length > 1) {
      let tmpSelectedGST = this.gstLedgerList.filter((o: any) => o.GST == this.gstINLocation);
      this.gstLedgerList = [];
      if (tmpSelectedGST.length > 0) {
        if (tmpSelectedGST[0].GSTLedgers) {
          this.gstLedgerList = tmpSelectedGST[0].GSTLedgers;
        }
      }
    }
    else if (this.gstLedgerList.length > 0) {
      let tmpGSTLedger: any = this.gstLedgerList;
      this.gstLedgerList = tmpGSTLedger[0].GSTLedgers;
    }

    if (this.gstLedgerList.length > 0) {
      this.gstLedgerList.forEach((o: any) => {
        if (o.type.endsWith('CGST-Out')) {
          this.gstLedger.cgstOut = o.ledgerName;
        }
        else if (o.type.endsWith('SGST-Out')) {
          this.gstLedger.sgstOut = o.ledgerName;
        }
        else if (o.type.endsWith('IGST-Out')) {
          this.gstLedger.igstOut = o.ledgerName;
        }
        else if (o.type.endsWith('CGST-In')) {
          this.gstLedger.csgtIn = o.ledgerName;
        }
        else if (o.type.endsWith('SGST-In')) {
          this.gstLedger.sgstIn = o.ledgerName;
        }
        else if (o.type.endsWith('IGST-In')) {
          this.gstLedger.igstIn = o.ledgerName;
        }
        else if (o.type.endsWith('CGST-ReverseChg-Out')) {
          this.gstLedger.cgstRevOut = o.ledgerName;
        }
        else if (o.type.endsWith('SGST-ReverseChg-Out')) {
          this.gstLedger.sgstRevOut = o.ledgerName;
        }
        else if (o.type.endsWith('IGST-ReverseChg-Out')) {
          this.gstLedger.igstRevOut = o.ledgerName;
        }
      });

      if (this.isAdminUser) {
        this.disAllowGSTLedger = false;
      }
      else {
        this.disAllowGSTLedger = true;
      }
    }
    else {
      this.gstLedger = this.defaultLedgers;
    }
  }

  // saveGSTLedger() - save data
  saveGSTLedger() {
    if (String(this.gstLedger.cgstOut).trim() == '') {
      this.apiService.successAlert('Please select CGSTOut.');
      return;
    }
    else if (String(this.gstLedger.sgstOut).trim() == '') {
      this.apiService.successAlert('Please select SGSTOut.');
      return;
    }
    else if (String(this.gstLedger.igstOut).trim() == '') {
      this.apiService.successAlert('Please select IGSTOut.');
      return;
    }
    else if (String(this.gstLedger.csgtIn).trim() == '') {
      this.apiService.successAlert('Please select CGSTIn.');
      return;
    }
    else if (String(this.gstLedger.sgstIn).trim() == '') {
      this.apiService.successAlert('Please select SGSTIn.');
      return;
    }
    else if (String(this.gstLedger.igstIn).trim() == '') {
      this.apiService.successAlert('Please select IGSTIn.');
      return;
    }
    else if (String(this.gstLedger.cgstRevOut).trim() == '') {
      this.apiService.successAlert('Please select CGST Reverse Ledger.');
      return;
    }
    else if (String(this.gstLedger.sgstRevOut).trim() == '') {
      this.apiService.successAlert('Please select SGST Reverse Ledger.');
      return;
    }
    else if (String(this.gstLedger.igstRevOut).trim() == '') {
      this.apiService.successAlert('Please select IGST Reverse Ledger.');
      return;
    }
    else {

      let tmpArry = [];

      let cgstOut = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.cgstOut);
      if (!cgstOut) {
        this.apiService.successAlert('Please select a valid CGST-Out Ledger.');
        return;
      }
      tmpArry.push({
        id: 1,
        ledgerID: cgstOut.LedgerID,
        type: 'CGST-Out',
        ledgerName: cgstOut.LedgerName
      });

      let sgstOut = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.sgstOut);
      if (!sgstOut) {
        this.apiService.successAlert('Please select a valid SGST-Out Ledger.');
        return;
      }
      tmpArry.push({
        id: 2,
        ledgerID: sgstOut.LedgerID,
        type: 'SGST-Out',
        ledgerName: sgstOut.LedgerName
      });

      let igstOut = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.igstOut);
      if (!igstOut) {
        this.apiService.successAlert('Please select a valid IGST-Out Ledger.');
        return;
      }
      tmpArry.push({
        id: 3,
        ledgerID: igstOut.LedgerID,
        type: 'IGST-Out',
        ledgerName: igstOut.LedgerName
      });

      let cgstIn = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.csgtIn);
      if (!cgstIn) {
        this.apiService.successAlert('Please select a valid CGST-In Ledger.');
        return;
      }
      tmpArry.push({
        id: 4,
        ledgerID: cgstIn.LedgerID,
        type: 'CGST-In',
        ledgerName: cgstIn.LedgerName
      });

      let sgstIn = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.sgstIn);
      if (!sgstIn) {
        this.apiService.successAlert('Please select a valid SGST-In Ledger.');
        return;
      }
      tmpArry.push({
        id: 5,
        ledgerID: sgstIn.LedgerID,
        type: 'SGST-In',
        ledgerName: sgstIn.LedgerName
      });

      let igstIn = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.igstIn);
      if (!igstIn) {
        this.apiService.successAlert('Please select a valid IGST-In Ledger.');
        return;
      }
      tmpArry.push({
        id: 6,
        ledgerID: igstIn.LedgerID,
        type: 'IGST-In',
        ledgerName: igstIn.LedgerName
      });

      let cgstRev = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.cgstRevOut);
      if (!cgstRev) {
        this.apiService.successAlert('Please select a valid CGST Reverse Charge Ledger.');
        return;
      }
      tmpArry.push({
        id: 7,
        ledgerID: cgstRev.LedgerID,
        type: 'CGST-ReverseChg-Out',
        ledgerName: cgstRev.LedgerName
      });

      let sgstRev = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.sgstRevOut);
      if (!sgstRev) {
        this.apiService.successAlert('Please select a valid SGST Reverse Charge Ledger.');
        return;
      }
      tmpArry.push({
        id: 8,
        ledgerID: sgstRev.LedgerID,
        type: 'SGST-ReverseChg-Out',
        ledgerName: sgstRev.LedgerName
      });

      let igstRev = this.ledgers.find((l: any) => l.LedgerName == this.gstLedger.igstRevOut);
      if (!igstRev) {
        this.apiService.successAlert('Please select a valid IGST Reverse Charge Ledger.');
        return;
      }
      tmpArry.push({
        id: 9,
        ledgerID: igstRev.LedgerID,
        type: 'IGST-ReverseChg-Out',
        ledgerName: igstRev.LedgerName
      });

      var duplicateIDs = tmpArry.map((e: any) => e['ledgerName']).map((e: any, i: any, final: any) => final.indexOf(e) !== i && i)
      duplicateIDs = duplicateIDs.filter((o: any) => o != false);
      
      if (duplicateIDs.length > 0) {
        this.apiService.successAlert('Please ensure that the GST ledgers are unique.');
        return;
      }

      let obj = [{
        ChangeType: 'GSTLDG',
        CfgGSTLedgers: JSON.stringify(tmpArry),
        GSTIN: this.gstINLocation
      }];

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'set',
        moduleID: 4,
        data: JSON.stringify(obj)
      }];

      this.apiService.sendChange(myParams, this.successCfgGstEntry.bind(this), this.failureCfgGstResp.bind(this));
    }
  }

  // deLinkLedgers() - De-link ledgers
  deLinkLedgers() {
    this.apiService.swalConfirm("Are you sure you want to de-link the GST ledgers?", () => {
      let obj = [{
        ChangeType: 'DLNKGSTLDG',
        CfgGSTLedgers: '[]',
        GSTIN: this.gstINLocation
      }];

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'set',
        moduleID: 4,
        data: JSON.stringify(obj)
      }];

      this.apiService.sendChange(myParams, this.successCfgGstEntry.bind(this), this.failureCfgGstResp.bind(this));
    });
  }

  // resetGSTModal() - reset object
  resetGSTModal() {
    this.gstLedger = this.defaultLedgers;
  }

  // successCfgGstEntry() - success handler 
  successCfgGstEntry(res: any) {
    if (res.error) {
      this.apiService.successAlert(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
      if (res) {
        const erpData = JSON.parse(res.updatePackage);
        if (erpData.Table1) {
          this.apiService.setCookie("ERP_Agn", JSON.stringify(erpData.Table1));
        }
        if (erpData.Table2) {
          this.apiService.setCookie("ERP_Cfg", JSON.stringify(erpData.Table2));
        }
      }

      this.activeModal.close('saved');
      this.resetGSTModal();
    }
  }

  // failureCfgGstResp - failure handler
  failureCfgGstResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

}